<template lang="pug">
  .commont-success
    .info
      img.banner(src="@/assets/images/shaanxi/success.png")
      p 您的订单已经受理！
    .mobile(v-if="mobile") 手机号码为：{{mobile}}
    .rule
      ol
        li
          | 号卡申请需符合国家实名制相关规定，我们会尽快审核，
          label.blue-color 并通过短信告知受理结果
        li
          | 审核通过后，我们将
          label.blue-color 委托快递人员为您上门激活号卡。
        li
          | 请提前准备好本人身份证，
          label.blue-color 号卡将在激活后交付您使用。
</template>

<script>
export default {
  data() {
    return {
      mobile: ''
    }
  },
  mounted() {
    this.mobile = this.$route.query.mobile
  }
}
</script>

<style lang="less" scoped>
.commont-success{
  padding: 0 3rem;
}
.info{
  font-size: 1.1rem;
  text-align: center;
  margin-top: 4rem;
  .banner{
    width: 64px;
    height: 64px;
  }
  p{
    font-weight: bold;
    font-size: 1.2rem;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
.mobile{
  margin-top: 2rem;
  text-align: center;
}
.rule{
  margin-top: 3rem;
  ol{
    list-style-type: decimal;
  }
  .blue-color {
    color: rgb(5, 96, 182);
  }
}
</style>